import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import { takeOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import React, { useCallback, useContext, useMemo } from 'react'
import { getDurationOptions } from 'selectors/multipleRoomBookingSelectors'
import { OfferDurationOption } from '../../DurationTabs/OfferDurationTabs'
import { min } from 'lib/arrayUtils'
import OfferDurationOptions from '../../Duration/OfferDurationOptions'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import { pluralizeToString } from 'lib/pluralize'

interface Props {
  durationOptions: Array<OfferDurationOption>;
  onClose?: () => void;
  offerId?: string;
  className?: string;
}

function OfferCalendarDurationDropdown(props: Props) {
  const { durationOptions, onClose, className } = props

  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)

  const minDuration = useMemo(() => min(durationOptions, duration => duration.duration)!, [durationOptions])
  const onDurationSelect = useCallback(() => {
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenDuration)
  }, [onUserAnalyticsAction])

  return (
    <DropdownContainer
      title="How long do you want to stay?"
      subtitle={`Minimum stay for this offer is ${pluralizeToString('night', minDuration.duration)}`}
      onClose={onClose}
      fit="dropdown-items"
      className={className}
    >
      <OfferDurationOptions onSelect={onDurationSelect} onClose={onClose} />
    </DropdownContainer>
  )
}

export default withOfferPageAndReduxState((state, appState, props) => {
  const currentOfferId = props.offerId ?? state.paginator?.currentOfferId
  const currentState = takeOfferState(state, currentOfferId)

  return {
    selectedDuration: currentState.duration,
    bundleOfferId: currentState.bundleOffer?.id,
    currentOfferId,
    durationOptions: getDurationOptions(currentState, appState),
    bundledWithFlightsOnly: currentState.offer?.bundledWithFlightsOnly,
  }
})(OfferCalendarDurationDropdown)
